import { Utils } from "@common/utils";

export function filterMenuItems(items = [], context, productAccesses) {
    return items
        .map((item) => {
            if (!Utils.isArrayWithData(item.children)) return item;

            const filteredChildren = filterSubMenuItems(
                item.children,
                context,
                productAccesses
            );

            item.disabled = filteredChildren.every((item) => item.disabled);
            return { ...item, children: filteredChildren };
        })
        .filter((item) => Utils.isArrayWithData(item.children));
}

function filterSubMenuItems(items = [], context, productAccesses) {
    return items
        .filter((item) => isValidItem(item, context))
        .map((item) => {
            disableItemsByProductAccess(item, productAccesses);
            if (!Utils.isArrayWithData(item.children)) return item;

            const filteredChildren = filterSubMenuItems(
                item.children,
                context,
                productAccesses
            );

            return { ...item, children: filteredChildren };
        });
}

function disableItemsByProductAccess(item, productAccesses) {
    const currentProductAccess = productAccesses.find((pa) =>
        item.path.includes(pa.pathname)
    );

    if (currentProductAccess) {
        item.disabled = !currentProductAccess.enabled;
    }
}

function isValidItem(item, context) {
    if (!item.validationRules || item.validationRules.length === 0) {
        return true;
    }

    return item.validationRules.every((rule) => rule(context, item));
}
